import { IRevenueSpendByAccountListTableLang } from '../../../types/lang'

export const revenueSpendByAccountListTableLang: IRevenueSpendByAccountListTableLang = {
	revenue_spend_by_account_list_table: {
		column_date: 'Date_ua',
		column_account: 'Account_ua',
		column_team: 'Team_ua',
		column_kt_group: 'KT Group_ua',
		column_revenue_cpa: 'Revenue Cpa_ua',
		column_revenue_offer_spend: 'Revenue Offer Spend_ua',
		column_revenue_total: 'Revenue Total_ua',
		column_spend: 'Spend_ua',
		column_roi: 'ROI, %_ua',
		column_account_fb: 'Accounts FB_ua',
		column_creo: 'Creo_ua',
		column_installs: 'Installs_ua',
		column_slices: 'Slices_ua',
		column_agency_percent: 'Agency percent_ua',
		column_profit: 'Profit_ua'
	}
}